module.exports = __webpack_public_path__ + "img/SmartGoals-Head.bb9c2e27.png";